
import { Vue, Component, Prop } from 'vue-property-decorator';
import SskAktifDetay from './SskAktifDetay.vue';
import BagkurAktifDetay from './BagkurAktifDetay.vue';
import KamuAktifDetay from './KamuAktifDetay.vue';
import SskEmekliDetay from './SskEmekliDetay.vue';
import BagkurEmekliDetay from './BagkurEmekliDetay.vue';
import KamuEmekliDetay from './KamuEmekliDetay.vue';
import IsyeriDetay from './IsyeriDetay.vue';
import { sskEmekliKayitlari } from '@/plugins/uyap-plugin/uyap/SskEmekli';

@Component({
  components: {
    SskAktifDetay,
    BagkurAktifDetay,
    KamuAktifDetay,
    SskEmekliDetay,
    BagkurEmekliDetay,
    KamuEmekliDetay,
    IsyeriDetay
  }
})
export default class BorcluSigortaBilgileri extends Vue {
  @Prop() borclu!: any;

  activeTab = 0;

  get borcluAdi() {
    if (this.borclu.borcluBilgileri) {
      // DosyaBorclu tipinde
      if (this.borclu.borcluBilgileri.adi) {
        return `${this.borclu.borcluBilgileri.adi} ${this.borclu.borcluBilgileri.soyadi}`;
      } else if (this.borclu.borcluBilgileri.kurumAdi) {
        return this.borclu.borcluBilgileri.kurumAdi;
      }
    }
    return 'Borçlu';
  }

  // Helper: Veri var mı kontrolü (EmptyObject veya boş obje değil mi?)
  hasValidData(obj: any): boolean {
    if (!obj) return false;
    if (!obj.sorguSonucu) return false;
    // EmptyObject kontrolü - constructor name ile
    if (obj.constructor && obj.constructor.name === 'EmptyObject') return false;
    // Boş obje kontrolü
    if (Object.keys(obj).length === 0) return false;
    return true;
  }

  get hasSskData() {
    return this.hasValidData(this.borclu.ssk);
  }

  get hasBagkurData() {
    return this.hasValidData(this.borclu.sgkbagkur);
  }

  get hasKamuData() {
    return this.hasValidData(this.borclu.sgkkamu);
  }

  // DEV-3514: "Aylık Ödenmemektedir" cevabında sorguSonucu false ama emekli kaydı geliyor; sekme yine gösterilir.
  get hasEmekliSskData() {
    return this.hasValidData(this.borclu.emekliSsk) || sskEmekliKayitlari(this.borclu.emekliSsk?.sorguSonucDVO).length > 0;
  }

  get hasEmekliBagkurData() {
    return this.hasValidData(this.borclu.emekliBagkur);
  }

  // DEV-3514: eski görevlerde emekliKamu SskEmekli cevabının kopyası (sorgulamaTuru "SSK Emeklisi");
  // aynı kayıt Kamu Emeklisi sekmesinde ikinci kez görünmesin.
  get hasEmekliKamuData() {
    return this.hasValidData(this.borclu.emekliKamu) && this.borclu.emekliKamu.sorgulamaTuru !== 'SSK Emeklisi';
  }

  get hasIsyeriData() {
    return this.hasValidData(this.borclu.sgkIsyeri);
  }

  // Herhangi bir veri var mı?
  get hasAnyData() {
    return this.hasSskData ||
           this.hasBagkurData ||
           this.hasKamuData ||
           this.hasEmekliSskData ||
           this.hasEmekliBagkurData ||
           this.hasEmekliKamuData ||
           this.hasIsyeriData;
  }
}
